/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
import {GtinValidationSetHeader} from "../models/gtin-validation-set-header";
import {GtinValidationSetService} from "../services/gtin-validation-set.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input()
export class GtinValidationSetPagingResolver implements Resolve<PagedResults<GtinValidationSetHeader>> {

  constructor(
    private  gtinService: GtinValidationSetService,

  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<GtinValidationSetHeader>> {
    try {
      return await this.gtinService.getGtinValidationSetHeaders(0, PAGING_ITEMS_PER_PAGE, 'ASC', "");
    } catch (error) {
      console.error("Problem resolving Locations... Error: " + error, error);
    }
  }

}
